import { ILoaderOption } from 'types'

export const compare = (a: ILoaderOption, b: ILoaderOption): number => {
  if (a.label < b.label) {
    return -1
  }

  if (a.label > b.label) {
    return 1
  }
  return 0
}
